import axios from 'axios';
import BASE_URL from '../../../config/config';
import React, { useState, useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { logout } from "../Controller/AuthController";
//import useFormSubmission from "../../services/AuthService/AuthService";
import useFormSubmission from "../Controller/AuthController";
import { AuthModel } from "../Model/AuthModel";
import { ThemeContext } from "../../Layout/Theme/ThemeContext";
import ModuleService from "../../Setup/controller/ModuleController/ModuleController";
import FormService from "../../Setup/controller/FormController/FormController";
import ClientLanguages from "../../Setup/controller/LanguageController/LanguageController";
import HelpLinkService from "../../SuperAdmin/Controller/Configuration/HelpLinkController";
import UserService from "../../Setup/controller/UserController/UserController";
import CompanySetupController from "../../SuperAdmin/Controller/Client/SACompanyListController";
import Swal from 'sweetalert2';
function Login() {
  debugger;
  logout();
  localStorage.clear();


  let count = 0;
  const navigate = useNavigate();
  const { theme } = useContext(ThemeContext);
  let accordTheme = "accordion-header-light";
  if (theme === "dark") {
    accordTheme = "accordion-header-dark";
  }
  const redirectCallback = () => {
    navigate('/'); // Redirect to the login page
  };
  const handleSubmit = useFormSubmission();
  useEffect(() => {
    logout();
  }, []);

  const handleFieldChange = (event) => {
    const { name, value } = event.target;

    if (name === "UserName" || name === "Password") {
      setIsCompanySelection(false);
      setSelectedCompany('0');
    }


    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const [errors, setErrors] = useState({});
  const [formData, setFormData] = AuthModel();
  const [errorMessage, setErrorMessage] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCompanySelection, setIsCompanySelection] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState('0');
  const [isMfaRequired, setIsMfaRequired] = useState(false);
  const [authCode, setAuthCode] = useState('');
  const [loginResponse, setLoginResponse] = useState(null);

  const onSubmit = async (event) => {
    debugger;
    event.preventDefault();
    if (selectedCompany === "0") {
      localStorage.setItem('MultipleCompanies', "0");
      formData.ClientID = "0";
      const response = await handleSubmit(event, formData, setFormData, setErrors, setErrorMessage);

      if (response.data.message === "Invalid username or password") {
        setErrorMessage("Invalid Credentials");
        return;
      }

      if (response.data.multipleCompanies === false) {
        // ✅ Check MFA
        const email = formData.UserName;
        const mfaCheck = await axios.post(`${BASE_URL}/Auth/getAuthStatus`, { email });
        if (mfaCheck.data.is_auth_enabled) {
          setLoginResponse(response);
          setIsMfaRequired(true);
        } else {
          naviageUser(response, "0");
        }
      } else {
        setCompanies(response.data.companies);
        setIsCompanySelection(true);
      }
    } else {
      formData.ClientID = selectedCompany;
      const response = await handleSubmit(event, formData, setFormData, setErrors, setErrorMessage);

      if (response.data.message === "Invalid username or password") {
        setErrorMessage("Invalid Credentials");
        return;
      }

      if (response.data.multipleCompanies === false) {
        const email = formData.UserName;
        const mfaCheck = await axios.post(`${BASE_URL}/Auth/getAuthStatus`, { email });
        if (mfaCheck.data.is_auth_enabled) {
          setIsMfaRequired(true);
        } else {
          naviageUser(response, "1");
        }
      }
    }
  };

  async function naviageUser(response, MultipleCompanies) {

    debugger;
    const IsAdminLogin = formData.IsAdminLogin;
    localStorage.setItem('token', response.data.companies[0].token); // Access token
    localStorage.setItem('refreshToken', response.data.companies[0].refreshToken); // Refresh token
    localStorage.setItem('CompanyID', response.data.companies[0].HostCompanyID);
    localStorage.setItem('RoleID', response.data.companies[0].RolesID);
    localStorage.setItem('UserID', response.data.companies[0].UserID);
    localStorage.setItem('DisplayName', response.data.companies[0].DisplayName);
    localStorage.setItem('Email', response.data.companies[0].UserName);
    localStorage.setItem('UserName', response.data.companies[0].Email);
    localStorage.setItem('CompanyName', response.data.companies[0].CompanyName);
    localStorage.setItem('Address1', response.data.companies[0].Address1);
    localStorage.setItem('ContractPrefix', response.data.companies[0].ContractPrefix);
    localStorage.setItem('AllowedUsers', response.data.companies[0].AllowedUsers);
    localStorage.setItem('RoleName', response.data.companies[0].RoleName);
    localStorage.setItem('EmailFooter', response.data.companies[0].EmailFooter);


    const ModuleList = await ModuleService.GetAllModules(redirectCallback, "en");
    localStorage.setItem('ModuleList', JSON.stringify(ModuleList));
    const FormList = await FormService.GetAllForms(redirectCallback);
    localStorage.setItem('FormList', JSON.stringify(FormList));
    const clientLanguage = await ClientLanguages.GetClientLanguage(redirectCallback, response.data.companies[0].HostCompanyID);
    localStorage.setItem('ClientLanguages', JSON.stringify(clientLanguage));
    const HelpLink = await HelpLinkService.GetAllHelpLinks(redirectCallback);
    if (HelpLink && HelpLink[0]) {
      localStorage.setItem('HelpLink', HelpLink[0].HelpLink);
    }
    localStorage.setItem('IsAdminLogin', IsAdminLogin);

    const user = await UserService.IsMultipleCompanies(response.data.companies[0].Email);
    debugger;
    if (user.length > 1) {
      localStorage.setItem('Companies', JSON.stringify(user));
      localStorage.setItem('MultipleCompanies', "1");
    }
    else {
      localStorage.setItem('Companies', JSON.stringify(user));
      localStorage.setItem('MultipleCompanies', "0");
    }

    let Isexpired = "0";
    if (response.data.companies[0].RoleName === "Administrator") {
      const companySetup = await CompanySetupController.GetCompanyByID(redirectCallback, response.data.companies[0].HostCompanyID);
      if (companySetup.length > 0 && companySetup[0].DaysLeft < 1) {
        Isexpired = "1";
        Swal.fire(
          '',
          `Your SAM license has expired.<br />
           Please renew it to continue using the system without any disruption.`,
          'error'
        );
      }
      else if (companySetup.length > 0 && companySetup[0].DaysLeft < 30) {
        Swal.fire(
          '',
          `Your SAM license will expire in (${companySetup[0].DaysLeft}) days`,
          'error'
        );
      }
    }
    localStorage.setItem('LicenseExpired', Isexpired);
    const isMobileDevice = () => window.innerWidth <= 768;
    if (isMobileDevice()) {
      navigate('/JobsListMobile');
    } else {
      navigate('/Dashboard');
    }
    // navigate('/Dashboard');
  }
  if (isMfaRequired) {
    return (
      <div className="auth-main-content auth-bg-image">
        <div className="d-table">
          <div className="d-tablecell">
            <div class="auth-box">
              <div class="row align-items-center">

                <div class="col-md-12">
                  <div class="form-content">
                    <div class="auth-logo">
                      <img src="assets/img/logo.png" alt="Logo" style={{ "width": "70%" }} />
                    </div>

                    <h1 class="heading">Two-Factor Authentication</h1>

                    <p>Enter the 6-digit code from your Authenticator App</p>
                    <input
                      type="text"
                      className="form-control text-center"
                      maxLength="6"
                      value={authCode}
                      onChange={(e) => setAuthCode(e.target.value)}

                    />
                    <div className="text-center mt-3">
                      <button
                        className="btn btn-primary"
                        onClick={async () => {
                          try {
                            const email = formData.UserName;
                            const res = await axios.post(`${BASE_URL}/Auth/verify-auth-code`, {
                              token: authCode,
                              email,
                            });
                            debugger;
                            if (res.data.success) {
                              if (loginResponse) {
                                // ✅ Use your standard user navigation logic
                                naviageUser(loginResponse, "0");
                              }
                            } else {
                              setErrorMessage("Invalid code. Try again.");
                            }
                          } catch (error) {
                            setErrorMessage("Verification failed.");
                          }
                        }}
                      >
                        Verify
                      </button>
                    </div>
                    {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (

    <div class="auth-main-content auth-bg-image">
      <div class="d-table">
        <div class="d-tablecell">
          <div class="auth-box">
            <div class="row align-items-center">

              <div class="col-md-12">
                <div class="form-content">
                  <div class="auth-logo">
                    <img src="assets/img/logo.png" alt="Logo" style={{ "width": "70%" }} />
                  </div>

                  <h1 class="heading">Log In</h1>
                  {errorMessage && <p className="text-center small" style={{ color: 'red' }}>{errorMessage}</p>}
                  <form class="" onSubmit={onSubmit}>
                    <div class="form-group">
                      <label class="form-label">User Name</label>

                      <input type="text" className='form-control txtUserName' name="UserName" value={formData.UserName} onChange={handleFieldChange} />
                      {errors.UserName && <div style={{ color: 'red' }}>{errors.UserName}</div>}
                    </div>
                    <div class="form-group">
                      <label class="form-label">Password</label>
                      <input type="password" className='form-control txtUserName' name="Password" value={formData.Password} onChange={handleFieldChange} />
                      {errors.Password && <div style={{ color: 'red' }}>{errors.Password}</div>}
                    </div>

                    {(isCompanySelection &&
                      <div>
                        <label class="form-label">Select Company</label>
                        <select className="form-control" value={selectedCompany} onChange={(e) => setSelectedCompany(e.target.value)}>
                          <option value="0">Select Company</option>
                          {companies.map(company => (
                            <option key={company.HostCompanyID} value={company.HostCompanyID}>
                              {company.CompanyName}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}


                    <div class="text-center mt-4">
                      <button type="submit" href="index.html" class="btn btn-primary btn-block btn-lg mt-3 rounded-pill">Log In</button>

                    </div>
                    <Link to="/ForgetPassword" type="button" className="">Forget Password</Link>
                  </form>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );



}

export default Login;
